import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
    maxWidth: '30rem',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 'fit-content',
    borderRadius: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    backgroundColor: '#1E1E1E;',
    padding: '1.5rem',
    wordBreak: 'keep-all!important',
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 1px rgba(0,0,0,0.1)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,.1)',
      outline: '1px solid slategrey',
    },
  },
  label: {
    fontSize: '19px',
    color: '#fff',
    width: '100%',
  },
  separater: {
    borderBottomWidth: '1px',
    borderBottomColor: '#A4A4A4',
    borderBottomStyle: 'solid',
    margin: '2px 0',
  },
  section: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px 6px',
  },
  tagsTitle: {
    fontSize: '14px',
    lineHeight: '20px',
    color: '#fff',
  },
  sectionTitle: {
    float: 'left',
    fontSize: '14px',
    lineHeight: '20px',
    marginRight: '4px',
    color: '#fff',
  },
  sectionText: {
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '20px',
    color: '#fff',
  },
  tag: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    fontSize: '13px',
    fontWeight: '300',
    padding: '4px 8px',
    whiteSpace: 'nowrap',
    backgroundColor: '#292929',
    borderRadius: '6px',
    border: '1px solid #404040',
  },
  lyricsContainer: {
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '20px',
    padding: '12px',
    color: '#fff',
    backgroundColor: '#292929',
    borderRadius: '4px',
    border: '1px solid #404040',
    whiteSpace: 'pre-line',
    maxHeight: '300px',
    overflowY: 'auto',
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888888',
      borderRadius: '8px',
    },
  },
  failMessage: {
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '20px',
    textAlign: 'center',
    padding: '12px',
    borderRadius: '4px',
    color: '#fff',
    backgroundColor: '#3d2929',
    border: '1px solid #e46962',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
}));

export { useStyles };
